export default __webpack_public_path__ + "assets/images/0ae24c869677076ac580b63922478409.svg";